const get = (url) => {
  return fetch(url)
      .then((response)=> {
    return response.json()
  })
};

const user='146740504@N02';
const api_key = '9470fcbc448530bad59ddcd1b6040790';

export const getAlbums = () => {
  return get(`https://api.flickr.com/services/rest/?method=flickr.photosets.getList&api_key=${api_key}&user_id=${user}&primary_photo_extras=url_m,date_taken&format=json&nojsoncallback=1`)
};

export const getPhotos = (album) => {
  return get(`https://api.flickr.com/services/rest/?method=flickr.photosets.getPhotos&api_key=${api_key}&photoset_id=${album}&extras=url_o,url_m&format=json&nojsoncallback=1`);
};


/** WEBPACK FOOTER **
 ** ./src/services/flickrServices.js
 **/